import * as React from 'react';
import { CommunityRequest } from '@shapeable/types';

export const CommunityRequestTypesContext = React.createContext<CommunityRequest[]>([]);
export const CommunityRequestTypesProvider = CommunityRequestTypesContext.Provider;